






















































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import VueRouter from "vue-router";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import EmployerPhone from "@/employer/components/shared/EmployerPhone.vue";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { BankCustodian } from "@/admin/types";

@Component({
  components: {
    Input,
    EmployerPhone,
    ErrorSummary
  }
})
export default class PartnerSupport extends Vue {
  $router: VueRouter;
  $validator: Validator;

  portalCustomizationStore = usePortalCustomizationStore();

  isSubmitting = false;
  supportPhone = "";
  supportEmail = "";
  supportWebsite = "";
  website = "";
  customFromEmail = "";
  emailHeaderImageUrl = "";
  emailButtonColor = "";
  emailButtonTextColor = "";
  status = "";
  allowedFileTypeRegex = "png|jpg|jpeg";
  isPrimaryContactServiceContact = false;
  primaryContactTitleOverride = "";
  primaryContactHoursConfig: "hide" | "default" | "custom" = "default";
  primaryContactCustomHours = "";
  secondaryContactPhone = "";
  secondaryContactShowPhone = false;
  secondaryContactEmail = "";
  secondaryContactTitle = "";
  secondaryContactHoursConfig: "hide" | "custom" = "hide";
  secondaryContactCustomHours = "";

  @Prop() partnerId: number;

  @Prop() custodian: BankCustodian;

  mounted () {
    this.onPartnerIdChanged(this.partnerId);
    this.initialize();
  }

  beforeMount () {
    this.$validator.extend("validateUrl", {
      getMessage: _ => {
        return "Please enter a valid URL.";
      },
      validate: _ => {
        const result = { valid: true, data: { required: true } };
        if (!this.emailHeaderImageUrl) {
          result.valid = false;
          return result;
        }

        const url = this.emailHeaderImageUrl.toLowerCase().trim();
        const regex = new RegExp(`.(${this.allowedFileTypeRegex})$`, "i");
        if (!regex.test(url)) {
          result.valid = false;
        }
        if (url.startsWith("https://")) {
          try {
            const url = new URL(this.emailHeaderImageUrl as string);
          } catch {
            result.valid = false;
          }
        } else {
          result.valid = false;
        }

        return result;
      }
    }, {
      computesRequired: true
    });
  }
  get isValidImageUrl (): boolean {
    return this.emailHeaderImageUrl && !this.$validator.errors.has("Email Header Image URL");
  }
  get showEmailHeaderImageUrl () {
    return this.custodian === BankCustodian.HsaBank;
  }

  onImageLoad (event) {
    this.status = "✅ Image loaded successfully!";
  }
  // Called when image fails to load
  onImageError (event) {
    this.status = "❌ Failed to load image.";
  }

  @Watch("partnerId")
  onPartnerIdChanged (partnerId) {
    this.portalCustomizationStore.getSupportInfo({ partnerId, employerId: 0 });
  }

  get submitDisabled () {
    return this.$validator.errors.any() || this.isSubmitting;
  }

  @Watch("portalCustomizationStore.isSupportInfoLoaded")
  initialize () {
    if (this.portalCustomizationStore.isSupportInfoLoaded && !this.portalCustomizationStore.supportInfo.isFallbackData) {
      this.supportPhone = this.portalCustomizationStore.supportInfo.supportPhone;
      this.supportEmail = this.portalCustomizationStore.supportInfo.supportEmail;
      this.supportWebsite = this.portalCustomizationStore.supportInfo.supportWebsite;
      this.website = this.portalCustomizationStore.supportInfo.website;
      this.customFromEmail = this.portalCustomizationStore.supportInfo.customFromEmail;
      this.emailHeaderImageUrl = this.portalCustomizationStore.supportInfo.emailHeaderImageUrl;
      this.emailButtonColor = this.portalCustomizationStore.supportInfo.emailButtonColor;
      this.emailButtonTextColor = this.portalCustomizationStore.supportInfo.emailButtonTextColor;
      this.isPrimaryContactServiceContact = this.portalCustomizationStore.supportInfo.isPrimaryContactServiceContact;
      this.primaryContactTitleOverride = this.portalCustomizationStore.supportInfo.primaryContactTitleOverride;
      this.primaryContactHoursConfig = this.portalCustomizationStore.supportInfo.primaryContactHoursConfig;
      this.primaryContactCustomHours = this.portalCustomizationStore.supportInfo.primaryContactCustomHours;
      this.secondaryContactPhone = this.portalCustomizationStore.supportInfo.secondaryContactPhone;
      this.secondaryContactShowPhone = this.portalCustomizationStore.supportInfo.secondaryContactShowPhone;
      this.secondaryContactEmail = this.portalCustomizationStore.supportInfo.secondaryContactEmail;
      this.secondaryContactTitle = this.portalCustomizationStore.supportInfo.secondaryContactTitle;
      this.secondaryContactHoursConfig = this.portalCustomizationStore.supportInfo.secondaryContactHoursConfig;
      this.secondaryContactCustomHours = this.portalCustomizationStore.supportInfo.secondaryContactCustomHours;
    }
  }

  submit () {
    this.$validator.validateAll()
        .then(isValid => {
          if (!isValid) {
            return;
          }

          this.isSubmitting = true;
          this.portalCustomizationStore.savePartnerSupportInfo({
                partnerId: this.partnerId,
                supportInfo: {
                  supportEmail: this.supportEmail,
                  supportWebsite: this.supportWebsite,
                  website: this.website,
                  supportPhone: this.supportPhone,
                  customFromEmail: this.customFromEmail,
                  emailHeaderImageUrl: this.emailHeaderImageUrl,
                  emailButtonColor: this.emailButtonColor,
                  emailButtonTextColor: this.emailButtonTextColor,
                  isPrimaryContactServiceContact: this.isPrimaryContactServiceContact,
                  primaryContactTitleOverride: this.primaryContactTitleOverride,
                  primaryContactHoursConfig: this.primaryContactHoursConfig,
                  primaryContactCustomHours: this.primaryContactCustomHours,
                  secondaryContactPhone: this.secondaryContactPhone,
                  secondaryContactShowPhone: this.secondaryContactShowPhone,
                  secondaryContactEmail: this.secondaryContactEmail,
                  secondaryContactTitle: this.secondaryContactTitle,
                  secondaryContactHoursConfig: this.secondaryContactHoursConfig,
                  secondaryContactCustomHours: this.secondaryContactCustomHours,
                }
              })
              .then(resp => {
                this.isSubmitting = false;
              });
        });
  }


}
